module.exports = __webpack_public_path__ + "static/media/privatkaffeeafricanblue.a89be64d.jpg";